import React, {useEffect, useState} from "react";
import {Alert, Backdrop, CircularProgress, Container, Pagination, styled} from "@mui/material";
import ContributionSearchPanel from "./ContributionSearchPanel";
import {ApiUrl} from "../utils/portal-urls";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import ShowSnackbar from "../utils/ShowSnackbar";
import ContributionsAsList from "./ContributionsAsList";
import {useDispatch, useSelector} from "react-redux";
import {CustomBackdrop, StyledContainer} from "../utils/customStyles";
import {getAllHisps} from "../features/allHispsSlice";




export default function ContributionHome () {

    const getParameters = getQueryParams();

    const [tableListLoading, setTableListLoading] = useState(false);
    const [refresh, setRefresh] = useState(new Date().getTime());
    const [page, setPage] = useState(getParameters.page ? parseInt(getParameters.page) : 0);
    const [pageResult, setPageResult] = useState(null);
    const [query, setQuery] = useState("");
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg:'', msgLv: ''});
    const [exportQuery, setExportQuery] = useState("");

    const {hispsLogo, allHispsLoading } = useSelector(state => state.allHisps);
    const dispatch = useDispatch();

    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0) {
            setPage(0);
        } else {
            fetchPage(query, page);
        }
    }, [query, page, refresh])

    useEffect(() => {
        dispatch(getAllHisps());
    }, [])


    const fetchPage = async (query, page) => {
        setTableListLoading(true);
        const url = ApiUrl.Contributions.query.getPath(query, page);
        console.log("GET contribution from: " + url);
        try {
            const res = await fetch(url)
            const data = await handleHttpResponse(res);
            setCurrentViewingQuery(query);
            setExportQuery(query);
            setPageResult(data);
        } catch (err) {
            console.error("failed to get contribution page: " + err)
            setSnackbarMsg({open: true, msg: 'Failed to Get Contribution Page', msgLv: 'error'});
        } finally {
            setTableListLoading(false);
        }
    }

    return (
        <StyledContainer maxWidth='xl'>
            <h3 className="title">
                Contributions
            </h3>
            <ContributionSearchPanel
                onRefresh={(r) => setRefresh(r)}
                onQueryStringChanged={(q) => setQuery(q)}
                setPage={(p) => setPage(p)}
                exportQuery={exportQuery}
            />
            <hr/>
            <div className="contribution-list-wrap">
                {pageResult &&
                    <Alert severity='info' icon={false}>
                        Found {pageResult.totalElements} record(s).&nbsp;
                        {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}
                    </Alert>}
                {pageResult?.content?.length > 0 && hispsLogo &&
                    <div>
                        <ContributionsAsList contributions={pageResult.content} setSnackbarOpen={(s) => setSnackbarMsg(s)} hispsLogo={hispsLogo}/>
                        <br/>
                        {pageResult.totalPages > 1 &&
                            <Pagination page={page + 1} count={pageResult.totalPages} variant="outlined" color="primary" onChange={(e, newPage) => setPage(newPage - 1)}/>}
                    </div>
                }

            </div>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={tableListLoading || allHispsLoading} />
        </StyledContainer>
    )
}